import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { Comment } from 'api/conversations';

const GROUPING_THRESHOLD = 2;

export const useIsFromSameUser = (
  comment: Comment,
  prevComment?: Comment,
): boolean => {
  const [isFromSameUser, setShowUserAvatar] = useState(false);

  const isFromSameUserCb = useCallback(() => {
    if (!prevComment) {
      return false;
    }

    if (comment.user.userId === prevComment.user.userId) {
      const diffInTime: number = moment(comment.createdAt).diff(
        prevComment.createdAt,
        'minute',
      );

      return diffInTime <= GROUPING_THRESHOLD;
    }

    return false;
  }, [comment.createdAt, comment.user.userId, prevComment]);

  useEffect(() => {
    setShowUserAvatar(!isFromSameUserCb());
  }, [isFromSameUserCb]);

  return isFromSameUser;
};
